module.exports = __webpack_public_path__ + "img/109ne.ddbff18a.svg";